import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { MenuItem, Select, TextField } from "@material-ui/core";
import NmefSpinner from "../NmefSpinner";

const TransferDialog = ({
	open,
	setOpen,
	title,
	content,
	transferPerson,
	setTransferPerson,
	transferOptions,
	setTransferOptions,
	transferDeal,
	app,
}) => {
	return (
		<div>
			<Dialog
				maxWidth
				open={open}
				onClose={() => setOpen(false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description">
				<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{content}
					</DialogContentText>
					{transferOptions?.length > 0 ? (
						<Select
							onChange={(e) => {
								console.log("person", e.target.value);
								setTransferPerson(e.target.value);
							}}
							style={{ width: "75%", marginLeft: "10%" }}>
							{transferOptions?.map((item) => (
								<MenuItem key={item.id} value={item}>
									{item.name}
								</MenuItem>
							))}
						</Select>
					) : (
						<NmefSpinner />
					)}
				</DialogContent>
				<div style={{ width: "75%", marginLeft: "17%" }}>
					<div>
						<Button
							disabled={Object.keys(transferPerson).length == 0 ? true : false}
							style={{ marginTop: "20px", marginBottom: "10px" }}
							onClick={() => {
								setOpen(false);
								transferDeal();
							}}
							variant="contained"
							color="primary">
							Submit
						</Button>
					</div>
				</div>
			</Dialog>
		</div>
	);
};
export default TransferDialog;
